import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const OrganigramaOperacional = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Organigrama Operacional</h1>
        </div>
        <div className="orgproc-grid">
          <div className="orgproc-card">
            <div className="orgproc-card-accent"></div>
            <div className="orgproc-card-body">
              <div className="orgproc-eyebrow">Proceso #1</div>
              <div className="orgproc-card-title">Estructura Operativa</div>
              <p className="orgproc-card-desc">
                El organigrama de operaciones de
                Netjer Networks es fundamental para comprender la
                estructura y funcionamiento interno de la organización.
                Este diagrama jerárquico representa la distribución de
                responsabilidades y roles dentro de Netjer, permitiendo
                una visión clara de estructura de trabajo.
              </p>
              <Link
                className="orgproc-card-btn"
                to="/organigrama-operacional/estructura-operativa"
              >
                Ver Organigrama →
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default OrganigramaOperacional;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
